<template>
	<div class="banner">
		<div class="swiper-container bannerSwiper" style="width: 100vw;height: 100vh">
			<div class="swiper-wrapper">
				<div class="swiper-slide swiper-no-swiping" style="width: 100vw;height: 100vh;">
					<img src="../static/images/img/banner.png" alt="">
				</div>
				<div class="swiper-slide swiper-no-swiping" style="width: 100vw;height: 100vh;">
					<img src="../static/images/img/banner3.png" alt="">
				</div>
				<div class="swiper-slide swiper-no-swiping" style="width: 100vw;height: 100vh;">
					<img src="../static/images/img/banner2.png" alt="">
				</div>
			</div>
		</div>
		<ul class="instructions_box">
			<li @click="swiperWay(0)" :class="swiperId == 0? 'instructionLi initialSlideClass':'instructionLi '"></li>
			<li @click="swiperWay(1)" :class="swiperId == 1? 'instructionLi initialSlideClass':'instructionLi '"></li>
			<li @click="swiperWay(2)" :class="swiperId == 2? 'instructionLi initialSlideClass':'instructionLi '"></li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				swiperId: 0,
				swiper: '',
			}
		},
		mounted() {
			var _this = this
			this.swiper = new Swiper('.bannerSwiper', {
				effect: "fade",
				initialSlide: _this.swiperId,
				loop: true,
				parallax: true,
				autoplay: 5000,
				onSlideChangeStart: function(swiper) {
					if (_this.swiper.activeIndex) {
						_this.swiperId = _this.swiper.activeIndex - 2
					}
				}
			})


		},
		methods: {
			swiperWay(i) {
				var _this = this
				_this.swiperId = i
				_this.swiper.slideTo(i, 1000, false)
			}
		}

	}
</script>

<style lang="scss" scoped>
	.banner {
		position: relative;
		width: 100%;
		height: 100%;

		img {
			width: 100%;
			height: 100%;
		}

		// .button_box {
		//   position: absolute;
		//   top: 60%;
		//   left: 50%;
		//   transform: translate(-50%, -50%);
		//   width: 30%;
		//   height: 30%;
		//   background-color: #fff;
		// }
	}
</style>
<style>
	.instructions_box {
		position: absolute;
		bottom: 0.1042rem;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		z-index: 10;
	}

	.instructionLi {
		width: 0.3646rem;
		height: 0.0729rem;
		background: #ffffff50;
		border-radius: 0.0365rem;
		margin: 0px 0.0521rem;
		transition: 0.3s;
		cursor: pointer;
	}

	.initialSlideClass {
		width: 0.8854rem !important;
		background-color: #ff6100 !important;
	}
</style>